import axios from 'axios'
import QueryParamsUtil from 'api/utils/query-params-util'

const API_PATH = 'api/v2/admins/sellers/market_products'

const SellerMarketProductsApiV2 = {
  /**
   * Get list of `Seller MarketProduct`
   * @param {object} tableState - ReactTable final state
   * @param {object} additionalFilters - A plain object to get customize filters outside `tableState`
   */
  get: async ({ tableState, additionalFilters }) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = API_PATH

    const response = axios.get(path, { params })
    return response
  },

  /**
   * Get single `Seller MarketProduct`for edit
   * @param {number} id - Seller Market Product ID
   */
  edit: async (id) => {
    const path = `${API_PATH}/${id}/edit`

    const response = axios.get(path)
    return response
  },

  /**
   * Update Seller Product Market
   * @param {number} id - Seller Market Product ID
   * @param {object} mainAttributeValues - main attribute Formik bag values
   * @param {object} variantAttributeValues - variant attribute Formik bag values
   */
  update: async ({
    id,
    mainAttributeValues,
    variantAttributeValues
  }) => {
    const { variants } = variantAttributeValues

    const path = `${API_PATH}/${id}`
    const body = {
      seller_market_product: {
        ...mainAttributeValues,
        variants: variants
      }
    }

    const response = axios.patch(path, body)
    return response
  },

  /**
   * Get single `Seller MarketProduct`
   * @param {number} id - Seller Market Product ID
   */
  show: async (id) => {
    const path = `${API_PATH}/${id}`

    const response = axios.get(path)
    return response
  },

  /**
   * Make a live `Seller MarketProduct`
   * @param {number} id - Seller Market Product ID
   */
  makeLive: async (id) => {
    const path     = `${API_PATH}/${id}/make_live`
    const response = axios.patch(path)
    return response
  },
  /**
   * Complete the photo edit process in particular `Seller MarketProduct`
   * @param {number} id - Seller Market Product ID
   */
  photoEdit: async(id) => {
    const path = `${API_PATH}/${id}/photo_edit`

    const response = axios.patch(path)
    return response
  },

  /**
   * Upload cover image and copy/paste the non-cover seller images to product image
   * @param {number} id - Product Id
   * @param {array} cover_image - Image File
   */
  photoCoverUpload: async ({
    id,
    cover_image
  }) => {
    const path = `${API_PATH}/${id}/photo_cover_upload`

    const formData = new FormData()

    formData.append('cover_image', cover_image)

    const response = await axios.patch(path, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response
  },

  /**
   * Complete the photo upload process in particular `Seller MarketProduct`
   * @param {number} id - Seller Market Product ID
   */
  photoUploadComplete: async(id) => {
    const path = `${API_PATH}/${id}/photo_upload_complete`

    const response = axios.patch(path)
    return response
  },

  /**
   * Set market product status to on review
   * @param {number} id - Seller Market Product ID
   */
  review: async(id) => {
    const path = `${API_PATH}/${id}/review`

    const response = axios.patch(path)
    return response
  },

  /**
   * Add curation note on seller market product
   * @param {number} id - Seller Market Product ID
   * @param {object} payload
   */
  addCurationNote: async(id, payload) => {
    const path = `${API_PATH}/${id}/add_curation_note`

    const response = axios.patch(path, payload)
    return response
  },

  /**
   * accept market product review
   * @param {number} id - Seller Market Product ID
   */
  accept: async(id) => {
    const path = `${API_PATH}/${id}/accept`

    const response = axios.patch(path)
    return response
  },

  /**
   * reject market product review
   * @param {number} id - Seller Market Product ID
   * @param {object} payload {
   *    reject_reason:
   *    reject_note:
   * }
   */
  reject: async(id, payload) => {
    const path = `${API_PATH}/${id}/reject`

    const response = axios.patch(path, payload)
    return response
  },
  /**
   * Convert `Fast Sell Product` to `Market Product`
   * @param {object} fastSellProduct Fast Sell Product object that we want to convert into Market Product
   * @param {object} fastSellConvertToMarketProductValues updated values expected (category and market product price offer) for converting fast sell to marketplace
   * @return {object} Detail of created market product
   */
  fromFastSell: async ({
    fastSellProduct,
    fastSellConvertToMarketProductValues
  }) => {
    const payload  = {
      fast_sell_product_id : fastSellProduct.id,
      product_category_id  : fastSellConvertToMarketProductValues?.product_category?.id,
      price_offer          : fastSellConvertToMarketProductValues?.price_offer
    }
    const path     = `${API_PATH}/from_fast_sell`
    const response = await axios.post(path, payload)
    return response
  },
  /**
   * Set market product status to pending
   * @param {number} id - Seller Market Product ID
   */
  finalizeIncompleteStatus: async (id) => {
    const path = `${API_PATH}/${id}/finalize_incomplete_status`

    const response = axios.patch(path)
    return response
  },
  /**
   * Convert `Consignment` to `Market Product`
   * @param {object} consignmentProduct Consignment Product object that we want to convert into Market Product
   * @param {object} consignmentConvertToMarketProductValues updated values expected (market product price offer) for converting consignment to marketplace
   * @return {object} Detail of created market product
   */
  fromConsignment: async ({
    consignmentProduct,
    consignmentConvertToMarketProductValues
  }) => {
    const payload  = {
      consignment_product_id : consignmentProduct.id,
      price_offer            : consignmentConvertToMarketProductValues?.price_offer
    }
    const path     = `${API_PATH}/from_consignment`
    const response = await axios.post(path, payload)
    return response
  }
}

export default SellerMarketProductsApiV2
